import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface OneNoteConfig {
    oneNoteApiPath: string;
    enableOneNoteApis: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class OneNoteConfigService {
    public readonly config: OneNoteConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<OneNoteConfig>('oneNoteConfig') || {
            oneNoteApiPath: null,
            enableOneNoteApis: false
        };
    }
}
